import { c as _c } from "react/compiler-runtime";
import { alpha, Box, Divider, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import sanitizeHtml from "sanitize-html";
import type { QuestionDataQueryResult } from "#/graphql/generated";
import { useI18nContext } from "#/shared/hooks";
import { DataSection } from "#/shared/ui/templates/DataSection";
import styles from "./DailyProblem.module.scss";
interface DailyProblemProps {
  questionDataQuery: QuestionDataQueryResult;
}
export const DailyProblem: React.FC<DailyProblemProps> = t0 => {
  const $ = _c(16);
  const {
    questionDataQuery
  } = t0;
  const theme = useTheme();
  const {
    LL
  } = useI18nContext();
  const question = questionDataQuery.data?.question;
  let t1;
  if ($[0] !== question) {
    t1 = question && sanitizeHtml(question.content, {
      allowedTags: ["img", "p", "strong", "ul", "li", "pre", "code"]
    });
    $[0] = question;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sanitizedContent = t1;
  const loading = questionDataQuery.loading;
  let t2;
  if ($[2] !== LL || $[3] !== question?.title) {
    t2 = question?.title || LL.DAILY_PROBLEM_FALLBACK_TITLE();
    $[2] = LL;
    $[3] = question?.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== LL) {
    t3 = LL.DAILY_PROBLEM_SECTION_CAPTION();
    $[5] = LL;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== question || $[8] !== sanitizedContent || $[9] !== theme) {
    t4 = question && <Box><Box className={styles.content} dangerouslySetInnerHTML={{
        __html: sanitizedContent ?? ""
      }} sx={{
        img: {
          borderRadius: theme.shape.borderRadius,
          maxWidth: "100%"
        },
        pre: {
          my: 1,
          borderRadius: theme.shape.borderRadius,
          background: alpha(theme.palette.primary.dark, 0.1)
        }
      }} /><Divider /></Box>;
    $[7] = question;
    $[8] = sanitizedContent;
    $[9] = theme;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== loading || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <DataSection title={t2} caption={t3} isLoading={loading}>{t4}</DataSection>;
    $[11] = loading;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};